export const METERS_PER_LAT_DEGREE = 111320;
export const LONG_JUMP_SPAN_RATIO = 6;
export const MIN_SPAN_DEGREES = 0.006;
export const MAX_SPAN_DEGREES = 1.2;

const clamp = (value, min, max) => Math.min(Math.max(value, min), max);

export const spansForRadius = ({ latitude, radiusMeters }) => {
  const latSpan = (2 * radiusMeters) / METERS_PER_LAT_DEGREE;
  const lngSpan = latSpan / Math.max(Math.cos((latitude * Math.PI) / 180), 0.01);

  return {
    latSpan: clamp(latSpan, MIN_SPAN_DEGREES, MAX_SPAN_DEGREES),
    lngSpan: clamp(lngSpan, MIN_SPAN_DEGREES, MAX_SPAN_DEGREES),
  };
};

export const boundsForRadius = ({ latitude, longitude, radiusMeters }) => {
  const { latSpan, lngSpan } = spansForRadius({ latitude, radiusMeters });

  return {
    north: latitude + latSpan / 2,
    south: latitude - latSpan / 2,
    east: longitude + lngSpan / 2,
    west: longitude - lngSpan / 2,
  };
};

export const isLongJump = (from, to, radiusMeters) => {
  if (!from || !to) return true;

  const { latSpan, lngSpan } = spansForRadius({
    latitude: to.latitude,
    radiusMeters,
  });

  const latAway = Math.abs(to.latitude - from.latitude) / latSpan;
  const lngAway = Math.abs(to.longitude - from.longitude) / lngSpan;

  return Math.max(latAway, lngAway) > LONG_JUMP_SPAN_RATIO;
};

export const regionKey = (coordinates, radiusMeters, refitToken) => {
  if (!coordinates) return "";

  return [
    coordinates.latitude.toFixed(4),
    coordinates.longitude.toFixed(4),
    radiusMeters,
    refitToken,
  ].join(":");
};
